import { defineStore } from "pinia";
import { ref } from "vue";
import { useApi } from "@/features/Api/useApi";

export const useUsersStore = defineStore(
  "useUsersStore",
  () => {
    const api = useApi();

    const users = ref([]);
    const loading = ref(false);
    const loadUsers = async () => {
      if (loading.value) {
        return;
      }
      loading.value = true;
      await api
        .get("/users")
        .then(({ data }) => {
          users.value = data;
        })
        .finally(() => (loading.value = false));
    };
    return {
      loadUsers,
      users,
    };
  },
  {
    persist: [
      {
        paths: ["users"],
        storage: sessionStorage,
      },
    ],
  }
);
